import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Http,Headers, RequestOptions } from "@angular/http";
import * as emiGlobals from 'app/globals';

@Component({
  selector: 'app-balance-transfer-offers',
  templateUrl: './balance-transfer-offers.component.html',
  styleUrls: ['./balance-transfer-offers.component.css']
})
export class BalanceTransferOffersComponent implements OnInit {


  constructor(private _http: Http) { }

  ngOnInit() {
  }
 

 
}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/balance-transfer-offers/balance-transfer-offers.component.ts